/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/


export default class ConsoleLogger {

   public info(message: string, ...args: any[]): void {
      console.log(message, args);
   }

   public warning(message: string, ...args: any[]): void {
      console.warn(message, args);
   }

   public error(message: string, ...args: any[]): void {
      console.error(message, args);
   }

}
